export const InitHeroImage = () => {
  const heroImage = document.querySelector<HTMLImageElement>('.hero-image__picture');

  if (heroImage) {
    if (window.innerWidth > 768) {
      heroImage.alt = heroImage.dataset['desktopAlt'] ?? '';
    } else {
      heroImage.alt = heroImage.dataset['mobileAlt'] ?? '';
    }
    window.addEventListener('resize', () => {
      if (self.innerWidth > 768) {
        heroImage.alt = heroImage.dataset['desktopAlt'] ?? '';
      } else {
        heroImage.alt = heroImage.dataset['mobileAlt'] ?? '';
      }
    })
  }
}
